 var $ = require('jquery');

/* enables all order buttons */
function enableButtons() {
    $('#mns #addNewWizard').attr("disabled", false).removeClass('disabled');
    $('#mns #send_calculation').attr("disabled", false).removeClass('disabled');
    $('#mns .order_button button').attr("disabled", false).removeClass('disabled');
}

/* disables all order buttons */
function disableButtons() {
    $('#mns #addNewWizard').attr("disabled", true).addClass('disabled');
    $('#mns #send_calculation').attr("disabled", true).addClass('disabled');
    $('#mns .order_button button').attr("disabled", true).addClass('disabled');
}

//if input value is out of range sets min or max value
function changeRangeValues() {
    $("#mns input[min],#mns input[max]").each(function(){
        var min = $(this).attr('min')*1;
        var max = $(this).attr('max')*1;
        var val = $(this).val()*1;
        if(val < min){
            $(this).val(min);
        } else {
            if(val > max){
                $(this).val(max);
            }
        }
    })
}

function getCalculateUrl() {
    let orderId = $('#order_order_id').val();
    let uploaderUploadUrl = RoutingS1.generate('productCalculate', {
        order_id: orderId,
        product_name: productSlug
    });
    if (!orderId || parseInt(orderId) < 1) {
        uploaderUploadUrl = RoutingS1.generate('productCalculate', {
            order_id: 0,
            product_name: productSlug
        });
    }
    return uploaderUploadUrl;
}

function askCalculation() {
    changeRangeValues();
    disableButtons();

    /* Show buttons on first calculation request (if they are not visible yet) */
    if (!$('#mns #send_calculation').is(":visible")) {
        $('#mns #send_calculation').show();
    }
    if (!$('#mns .order_button button').is(":visible")) {
        $('#mns .order_button button').show();
    }

    var fields = $("#mns #simple_form").serializeArray();
    // adds not checked options to the request
    let notChecked = $('#mns #simple_form input[type=checkbox]:not(:checked)');
    fields = fields.concat(notChecked.map(function() {
        return {
            name: this.name,
            value: 0
        }
    }).get());

    $("#mns #calculation_details")
        .html('<img src="/images/loader.gif" style="margin: 0pt auto; display: block;" />')
    ;
    $.post(getCalculateUrl(), {
        fields: fields
    }, function(html) {
        $("#mns #calculation_details").html(html);
        $('#mns #send_calculation_form').hide();

        if (!html.match('(error)')) {
            enableButtons();
        }

        $("#mns .calculation-group .item").click(function() {
            var val = $(this).children('td.quantity').html();
            $('#order_quantity').val(val);
            askCalculation();
        });

        $('#mns').trigger('mnumi:calculation:result', html);
    });
}

$(document).ready(function() {
    $.fn.askCalculation = function() {
        askCalculation();
    };


    // calculation
    askCalculation();
    var calculationTimeout = null;

    $('#mns')
        .on('change', '#simple_form #form select, #simple_form #form input', function() {
            clearTimeout(calculationTimeout);

            calculationTimeout = setTimeout(askCalculation, 250);
        })
    ;

    // unbinds checkbox click when required
    $(".unclickable").next("span").unbind("click");
    //SH-404
    $("#mns #simple_form input[readonly]").unbind("change");

    $(document)
        .on('mnumi:order:recalculate.count', function() {
            var totalCount = 0;
            $('#mns #ms-product-upload .prints-number').each(function(i,n) {
                totalCount += parseInt($(n).val());
            });

            console.log('mnumi:order:recalculate.count = ' + totalCount);
            var orderCountInput = $('#mns input#order_count');
            orderCountInput.attr('min', 1);
            if (totalCount > 0) {
                orderCountInput.attr('min', totalCount).val(totalCount).change();
            }
        })
    ;
});
